module.exports = __webpack_public_path__ + "static/media/empty_loc_fetch.01524d3b.png";